import { isResponseError } from 'up-fetch'

export const parseError = async (error: unknown) => {
  if (isResponseError(error)) {
    const errorMessage = (await error.response.json()).message
    return errorMessage
  }
}
